import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, ValidateNested } from "class-validator";
import { CategoryEntity } from "../../entity";

export class GetAllCategoryDTO {
  @Expose()
  @ValidateNested()
  @IsArray()
  @Type(() => CategoryEntity)
  data!: CategoryEntity[];

  @Expose()
  @IsNumber()
  count!: number;

  @Expose()
  @IsNumber()
  page!: number;

  @Expose()
  @IsNumber()
  pageSize!: number;
}
